import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=138e0716&scoped=true&"
import script from "./ActivityInfo.vue?vue&type=script&lang=js&"
export * from "./ActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=138e0716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e0716",
  null
  
)

export default component.exports